<template>
  <d2-container>
      <el-form
        :model="form"
        ref="form"
        size="small"
        label-width="300px"
      >
        <el-form-item
                prop="one_retail"
                label="一级分销比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input  @keyup.native="changeAmount"  v-model="form.one_retail"></el-input>
        </el-form-item>
        <el-form-item
                      prop="two_retail"
                      label="二级分销比例（%）"
                      :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount2"  v-model="form.two_retail"></el-input>
        </el-form-item>
        <el-form-item
                prop="three_retail"
                label="三级分销比例（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount3"  v-model="form.three_retail"></el-input>
        </el-form-item>
        <el-form-item
                prop="group_integral"
                label="发团人拼成功送补贴（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount4"  v-model="form.group_integral"></el-input>
        </el-form-item>
        <el-form-item
                prop="middle_integral"
                label="拼中送积分（%）"
                :rules="[{ required: true, message: '不能为空且为数字'}]"
        >
          <el-input @keyup.native="changeAmount5" v-model="form.middle_integral"></el-input>
        </el-form-item>


        <el-form-item>
          <el-button
                  type="primary"
                  :loading="loading"
                  @click="saveUser"
          >保存</el-button>
        </el-form-item>
      </el-form>

  </d2-container>
</template>
<script>
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
export default {
  name: "ShopsPage",
  components: { },
  data() {
    return {
        loading: false,
        form: {
          userCode: ""
      }
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      changeAmount () {
          this.form.one_retail = this.form.one_retail.replace(/[^\d.]/g, '')
      },
      changeAmount2 () {
          this.form.two_retail = this.form.two_retail.replace(/[^\d.]/g, '')
      },
      changeAmount3 () {
          this.form.three_retail = this.form.three_retail.replace(/[^\d.]/g, '')
      },
      changeAmount4 () {
          this.form.group_integral = this.form.group_integral.replace(/[^\d.]/g, '')
      },
      changeAmount5 () {
          this.form.middle_integral = this.form.middle_integral.replace(/[^\d.]/g, '')
      },


      saveUser() {
          this.$refs["form"].validate(valid => {
              if (valid) {
                /**  if(this.form.user_recom_scale<70){
                      this.form.user_recom_scale ="";
                     return false;
                  }**/

                  this.loading = true;
                  agentService.saveRetaillevel({ ...this.form,xt_id:util.cookies.get('xt_id'),agentid:util.cookies.get('agentid')})
                      .then(data => {
                          this.loading = false;
                      });

              } else {
                  return false;
              }
          });
      },
    getTableData() {
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("xt_id",util.cookies.get('xt_id'));
        agentService.getRetaillevelXq(formData4).then(data => {
            if(data!=null && data!=""){

                let form = {};

               form.one_retail=data.one_retail;
                form.two_retail=data.two_retail;
                form.three_retail=data.three_retail;
                form.group_integral=data.group_integral;
                form.middle_integral=data.middle_integral;


                this.form = form;
            }
        });
    }

  }
};
</script>
